import SafeDrivingNavigationUpdateBottomSheetKr from '@di-shared/features/safe-driving/kr/SafeDrivingNavigationUpdateBottomSheet.kr';
import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 400;

function SafeDrivingNavigationUpdateBottomSheetPage() {
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <SafeDrivingNavigationUpdateBottomSheetKr />
    </BottomSheetWebViewWrapper>
  );
}

export default SafeDrivingNavigationUpdateBottomSheetPage;
